import { render } from "./PageTemplateEmail.vue?vue&type=template&id=28b82ee0"
import script from "./PageTemplateEmail.vue?vue&type=script&lang=js"
export * from "./PageTemplateEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__